import {AbstractParameter} from './AbstractParameter.js';
import {convertValue} from './convertPatternToValue.js';

/**
 * Create parameters that have several options, but still
 * use a number from 0-1 underneat it all
 * Expects an option config parameter thats a mapping from 
 * numbers between 0-1 to the string it represents
 */
class OptionParameter extends AbstractParameter {
    constructor(name, audioParam, setter, config={}) {
        super(name, audioParam, setter, config);
    }

    get options() {
        return this.config.options;
    }

    getOptionFromNumber(number) {
        number = parseFloat(number);

        if (number in this.fromCache) {
            return this.fromCache[number];
        }

        let minDistance = 10000;
        let option = undefined;

        for (let key  in this.options) {
            let distance = Math.abs(number - parseFloat(key));
            if (distance < minDistance) {
                minDistance = distance;
                option = this.options[key];
            }
        }

        this.fromCache[number] = option;
        return option;
    }

    getNumberFromOption(option) {
        if (option === undefined) {
            return undefined;
        }

        if (option.toString() in this.toCache) {
            return this.toCache[option.toString()];
        }

        for (let i in this.options) {
            if ((option.equals && option.equals(this.options[i])) ||
                 this.options[i] === option) {
                this.toCache[option.toString()] = parseFloat(i);
                return parseFloat(i);
            }
        }

        // otherwise find the closest one
        return undefined;
    }

    convertValue(o) {
        let converted = convertValue(o);
        return this.getOptionFromNumber(o);
    }

    // i.e. set(MIX_MODE) -> set(1)
    set(option, automation, bulk, force) {
        if (option === null || option === undefined) {
            return super.set(undefined, automation, bulk);
        }
        let number = force ? option :
            !this.config.isNumber && typeof option === 'number' ? option :
            this.getNumberFromOption(option);
        if (number === undefined) {
            number = Object.values(this.options)[0];
        }

        // figure out number from options
        return super.set(number, automation, bulk);
    }

    getNumber(force) {
        return super.get(force);
    }

    get(force) {
        let number = super.get(force);

        // convert to option
        if (number in this.options) {
            return this.options[number];
        }
        return this.getOptionFromNumber(number);
    }

    // called when switch to pattern happens
    updateRedux(isBulk=false, time) {
        // clear all patternToAutomations
        for (let i in this.patternToAutomation) {
            this.patternToAutomation[i].clear();
        }

        // TODO: need to clear the old automation and
        // schedule the new, for the remainder of the beat
        this.unlockedAutomation.clear();
        this.automation.clear();
        this.automation.store = this.store;
        this.mixAutomation.store = this.store;

        // TODO: this needs to be bulk updated for christ sake
        this.automation.updateRedux();
 
        if (this.value !== null && this.value !== undefined) {
            return this.set(this.value, true, isBulk, true);
        }
    }
}

export default OptionParameter;
